//法语
export default {
	userDrawer:{ //抽屉导航
		data:[
			{name:'Accueil'},
			{name:'Recherche'},
			{name:'Catégorie'},
			{name:'Panier'},
			{name:'Collection'},
			{name:'Mon'},
			{name:'Langues'}
		],
		language:[
			{name:'En chinois'},
			{name:'Anglais'},
			{name:'Français'},
			{name:'Le thaï'},
			{name:'Laotien en langue'},
			{name: 'Espagnol'}
		]
	},
	page:{
		index:{ //首页
			mainNav:[
				{name:'Catégories'},
				{name:'Collections'},
				{name:'Commandes'},
				{name:'Adresse'},
			],
			coupons:'Coupons',
			titProduct:'Produits populaires',
			titNow:'Meilleurs ventes',
			titCate:'Catégories distinctives',
			titBtn:'Voir tout',
			titAlso:'Pourrais aussi aimer',
			couponDesc:'Montant de la commande',
			received:'Reçu',
			orMore:'En savoir plus',
			viewDetails:'Vérifier les détails',
			recommended: 'Caractéristiques',
			promotions: 'Promotion',
			onView:'Voir les produits',
			collectSite: 'Ajoutez notre site à vos favoris',
			applyFor: 'Demander un magasin à long terme',
			mobileMall: 'Centre commercial mobile',
			shopStreet: 'rue commerçante',
			customerService: 'Service Clients',
			top: 'Haut',
			topOne: 'Classement',
			footer1: 'Variété complète',
			footer2: 'Livraison rapide',
			footer3: 'Produit authentique',
			footer4: 'petit prix tous les jours',
			address: "Salle 1101-04, bloc A, Qihang Times Square, avenue Xixian, district de Weiyang, ville de Xi'an, province du Shaanxi",
			icp: "Xi'an Zhongbang Network Technology Co., Ltd Shaanxi ICP n° 14011498-3",
		},
		goodsDetail:{ //商品详情
			search:'Rechercher des produits',
			sales:'Ventes',
			oldPrice:"Prix d'origine",
			inventory:'En stock',
			coupons:'Coupons',
			choose:'Choisi',
			choose1:'Sélectionner',
			Reviews:'Évaluation',
			good:'Meilleures évaluations',
			details:'Détails sur le produit',
			recommend:'Offres en vedette',
			home:'Accueil',
			like:'Oui.',
			cart:'Panier',
			addCart:'Panier',
			buyNow:'Achats',
			soldOut:'Rupture de stock',
			sold: 'Vendu',
			type:'Types disponibles',
			navList:[
				{name:'Articles'},
				{name:'Évaluation'},
				{name:"recommend"},
				{name:'Détails'}
			],
			select:'Produit sélectionné',
			clear:'Vide',
			settle:'Arrêter un compte',
			num:'Quantités',
			confirm:'Confirmé',
			cancel: 'Annulation',
			assure:"services"
		},
		goodsList:{
			navTitle:'Liste de produits',
			search:'Rechercher par nom de produit',
			default:'Par défaut',
			price:'Prix',
			sales:'Vente',
			new:'Nouveau produit',
			empty:'Aucun produit pour le moment, voyons autre chose svp',
			no: 'Non, plus maintenant',
			more: 'Charger plus',
			nono: "J'ai aussi des résultats",
			nomer: 'Pas de magasin pour le moment'
		},
		user:{
			navTitle:'Mon',
			like:'Mes collections',
			integral:'Mes scores',
			coupons:'Coupons',
			orderCenter:'Centre de commandes',
			myOrder:'Mes commandes',
			placeLogin:'Veuillez cliquer pour vous connecter',
			orderStatus:[
				{name:'payer'},
				{name:'expédier'},
				{name:'recevoir'},
				{name:'évaluer'},
				{name:'Remboursement'},
				{name:'Terminé'},
				{name:'Reçu'}
			],
			services:'Autres services',
			address:'Adresses',
			contact:'Contactez le service à la clientèle',
			applicationRecord: 'Collection de magasins',
			goodsCollection: 'Collection de marchandises',
			record: 'Dossier de demande',
			mineNav: [
				{name: 'Mes commandes'},
				{name: 'Liste des remboursements'},
				{name: 'Liste des évaluations'}
			],
			qunTitle: 'ข้อมูลใบอนุญาตประกอบธุรกิจ',
			qunDesc: 'ตามข้อกำหนดของการบริหารรัฐสำหรับอุตสาหกรรมและการพาณิชย์ "มาตรการจัดการธุรกรรมออนไลน์" ข้อมูลใบอนุญาตธุรกิจร้านค้าออนไลน์ได้รับการเผยแพร่ดังนี้:',
			qunCode: 'กรุณาใส่รหัสยืนยันภาพ',
			ubmit: 'nous faire parvenir',
		},
		goodsSearch:{
			navTitle:'Recherche de produit',
			place:'Cliquez pour rechercher des produits',
			search:'Recherche',
			hotSearch:'Recherche très demandé',
			recommend:'Proposition très demandé',
			emptySearch:'Aucun critère de recherche, essayez un autre mot svp',
			placeSearch:'Veuillez saisir les éléments à rechercher',
			onSearch:'Recherche en cours',
			goods:'Produits de base',
			mer: 'Merchant',
			merchantType: 'Type de magasin',
			merchantClassify:'Classification des commerçants',
			sure :"C'est sûr",
			reset: 'Réinitialiser',
			open: 'Élargir tout',
			up: 'Range ça',
			sort: 'trier',
			Default: 'défaut',
			Seller: 'Ventes',
			Price: 'le prix',
			searchMer: 'Désolé, le magasin que vous avez recherché na pas été trouvé~',
			searchGoods: 'Désolé, rien en rapport avec votre recherche na été trouvé~',
		},
		goodsAddcart:{
			navTitle:'Panier',
			labelNav:'Fournir une qualité de produit à 100% et un service après-vente',
			buyNum:'Quantités des achats',
			management:'Management',
			cancel:'Annuler',
			attribute:'Attributs',
			failureGoods:'Marchandises périmées',
			empty:'vide',
			failure:'périmé',
			fallDesc:'Cet article a expiré',
			selectAll:"Tous",
			buyNow:'Achater immédiatement',
			like:'Collections',
			delete:'Supprimer',
			emptyCart:'Aucun article  pour le moment, ajoutons quelque chose svp',
			again: 'Sélectionner à nouveau les spécifications',
			reselect :'Re - Select',
			productInfo: 'Informations sur le produit',
			unitPrice: 'Prix unitaire',
			quantity: 'Quantité',
			total: 'Total',
			operate: 'Opération',
		},
		orderPayStatus:{
			success:'Paiement réussi',
			fail:'Paiement échoué',
			orderId:'Numéro de commande',
			orderTime:'Temps de commande',// order of time
			payType:'Mode de paiement',
			payPrice:'Montant du paiement', //Pay the amount
			failReason:"Raison de l'échec", //The reason for failure
			viewOrder:'Vérifier la commande',//To view the order
			backHome:'Retour à la première page'
		},
		orderDetails:{
			navTitle:'détail de la commande',
			item:'Articles',// item(s)
			Customer:'Contactez le service à la clientèle',
			orderId:'Numéro de commande',
			copy:'Copie',
			orderTime:'Temps de commande',
			refundTime: 'Délai de remboursement',
			payStatus:'Statut de paiement',
			payTrue:'Payé',
			payFalse:'Non payé',
			payType:'mode de paiement',
			message:"Message de l'acheteur",
			name:'Destinataire',
			phone:'Téléphone',
			address:'Adresse de livraison',
			returnReason:'Raison du retour',
			returnMsg:'Instructions de remboursement',
			returnImg: 'Pièce justificative',
			sendMethod:'Méthode de livraison',
			sendOne:'Livraison', //send
			sendTwo:'Livraison', //The delivery
			CourierCompany:'Entreprise de messagerie',//Courier company
			CourierNo:'Numéro de suivi', //Courier number
			deliveryName:"Nom de l'expéditeur",
			deliveryPhone:'Téléphone',
			Virtual:'Expédition  virtuelle',//Virtual delivery
			deliveryMsg:'A été expédié, veuillez faire attention à vérifier',
			allPrice:'Prix total',
			freight:'Prix de livraison',
			coupon:'Déduction de coupon', //Coupon deduction
			point:'Déduction de points', //Points deduction
			actualPayment:'Paiement réel',//actual payment
			cancelOrder:'Annuler la commande',
			nowPay:'Paiement immédiat',
			refund:'Demande du retour',
			logistics:'Voir la vitesse du livraison',
			confirm:'Réception confirmée',
			delete:'Effacer la commande',
			again:'Racheter',
			confirmInfo: "Pour protéger les intérêts, veuillez confirmer la réception des marchandises après avoir reçu la confirmation qu'elles sont correctes.",
			confirmDel: "Confirmer la suppression de l'ordre",
			confirmCancel: "Confirmer l'annulation de la commande",
			calSU: 'Annulation réussie',
			operationSU: 'Opération réussie'
		},
		users:{
			userInfo:{
				navTitle:'Paramètres',
				avatar:'Avatar',
				name:'Surnom',
				email:'Email',
				password:'Mot de passe',
				save:'Sauvegarder les modifications',
				logOut:'retrait du  la connexion',
				phone:'Téléphone',
				msg: "Le nom de l'utilisateur ne peut pas être vide",
				personalCenter: 'centre personnel',
			},
			orderConfirm:{
				setAddress:"Définir l'adresse de livraison",
				navTitle:'Passer la commande',
				items:'Articles',
				coupons:'Coupons',
				integral:'Déduction de points',
				freight:'Frais de livraison',
				note:'Informations signalé',
				payPal:'Payer',
				allPrice:'Prix total',
				remaining:'Points restants',
				newIntegral:'Points actuels',
				free:'Livraison gratuite',
				placeNote:'Veuillez ajouter une note (moins de 150 caractères)',
				CouponDeduction:'Déduction de coupon',
				total:'Total',
        payment: 'Veuillez balayer le Code pour terminer le paiement',
        paymentResults: 'Payé',
        paymentResultsNo: 'Non payé',
			},
			orderList:{
				navTitle:'Mes commandes',
				orderNum:"L'ordre de consommation", //Cumulative order
				total:'Consommation totale',//Total consumption
				orderStatus:[
					{name:'En attente de paiement'},
					{name:'En attente de livraison'},
					{name:'Réception en attente'},
					{name:'Commentaire en attente'},
					{name:'Après vente/Remboursement'},
				],
				item:'Articles',// item(s)
				totalPay:'Montant total',//total payment
				cancelOrder:'Annuler la commande',
				viewDetails:'Vérifier les détails',
				evaluation:'Evaluation (tout du suite)',//evaluation
				evaluated:'évalué',//evaluation
				delete:'Effacer la commande',
				empty:"Pas d'informations sur la commande",
				pay:'Paiement immédiat',
				complete:'Fini',
				orderInfo: 'Informations sur la commande',
			},
			userCoupon:{
				navTitle:'Mes coupons',
				available:'Inutilisé',
				expired:'Utilisé/Expiré',
				min:'Réduction complète',
				can:'Disponible',
				used:'Expiré',
				general:'Générale',
				goods:'Produits',
				cate:'Catégories',
				receive:'Recevoir',
				received:'Reçu',
				receivedInfo:'Disponible dans les',
				receivedInfo1:'jours suivant la réception',
				navList:[
					{name:'Entreprises'},
					{name:'Produits'},
					{name:'Catégories'},
				],
				empty:'Aucun coupon disponible (pour le moment)',
				valid:'Période de validité',
				day:'Jour',
        minus: 'minus',
        getUsers: 'utiliser'
			},
			userGoodsCollection:{
				navTitle:'Mes collections',
				item:'Articles',
				management:'Management',
				cancel:'Annuler',
				empty:'Pas encore de favoris, dépêchez-vous et suivez-le~'
			},
			userAddressList:{
				navTitle:'Gestion des adresses',
				default:'Adresse par défaut',
				add:'Ajouter une nouvelle adresse',
				emptyAddress:"Aucune information d'adresse( pour le moment)",
        edit:'Révision',
        del:'Supprimer',
        sureDel: 'Êtes - vous sûr de vouloir supprimer cette adresse'
			},
			userAddress:{
				navTitle:'Gestion des adresses',
				name:'Nom',
				Email:'Email',
				country:'Pays',
				address:'Adresse',
				postCode:'Code postal',
				phone:'Numéro de téléphone',
				default:'Adresse par défaut',
				save:'Conserver',
				place:'Entrer svp'
			},
			userReturnList:{
				navTitle:'Retours',
				orderId:'No de remboursement',
				item:'tem(s)',
				total:'Montant du remboursement',
				refunding:'Remboursement en cours',
				refunded:'Remboursé',
				examine: 'Examen des entreprises en cours',
				examineInfo: "Vous avez lancé avec succès la demande de remboursement, veuillez patienter jusqu'à ce que le marchand traite; S'il vous plaît négocier avec le commerçant avant le remboursement, ce qui aidera à mieux traiter les problèmes après - vente",
				examine1: 'Le marchand a remboursé',
				refuse: 'Refus de remboursement',
				refuseReason: 'Motifs du refus：',
				refuseReason2: 'Le remboursement a été accepté avec succès, si le marchand a envoyé les marchandises, veuillez les retourner dès que possible; Merci pour votre soutien',
			},
			goodsCommentList:{
				navTitle:'Commentaires clients',
				score:'Noté',
				good:'Taux avantageux',
				all:'Total',
				goodScore:'Commentaires positifs',
				general:'Note modérée',
				bad:'Commentaires critiques',
				attribute:'Attribut',
				seller:'Vendeur'
			},
			goodsCommentCon:{
				navTitle:'Commentaires client',
				score:[
					{name:'Qualité des produits'},
					{name:'Attitude de service'}
				],
				place:"Le produit répond-il à vos attentes? Dites-nous ce que vous en pensez et partagez-le avec ceux qui veulent l'acheter!" ,
				upload:'Télécharger une image',
				submit:'Évaluer maintenant',
				tips: 'Merci pour vos commentaires',
				tipsWrite: "S'il vous plaît, écrivez ce que vous avez appris sur le bébé.",
        SU: "Succès de l'évaluation",
        tipsSU:'Nous continuerons à vous fournir des biens et des services de meilleure qualité'
			},
			goodsReturn:{
				navTitle:'Demande de retour ', //Application for return
				number:'Quantité retournée',
				price:'Montant du remboursement',
				reason:'Raison du retour',
				info:'Signalé',
				voucher:'Télécharger le certificat',
				place:'Remplissez les remarques, dans les 100 mots.',
				submit:'Demande de retour' ,//Request a refund
				upload:'Télécharger le certificat',
        detal:'Détails du remboursement',
        information: 'Informations sur le remboursement',
        refundList: 'Liste des remboursements'
			},
			login:{
				placeEmail:"Entrez l'e-mail",
				placePasd:'Mot de passe',
				sign:'Identifiez-vous ',//SIGN IN
				create:'Créer votre compte', //Create account
				forget:'Mot de passe oublié',
				quick:'Connexion rapide',
				pasdLogin:'Connexion par mot de passe',
				with:'Autres modes du connexion',
				Pasdagain:'Confirmer le mot de passe',
				submit:'Soumettre',
				next:'Continuer',
				reset:'Réinitialiser le mot de passe',
				resetDesc:"Veuillez entrer votre e-mail pour recevoir la vérification",
				emailVer:"Vérification de l'E-mail",
				verDesc:'Pour la sécu rité de votre compte, veuillez vérifier votre adresse e-mail.',
				tourists:'Achat anonyme',
				continue:'Continuer',
				phoneVer:'Téléphone',
        remember: 'Rappelez-vous votre mot de passe ?'
			},
			register:{
				tabNav:[
					{name:'Email'},
					{name:'Téléphone'}
				],
				placeEmail:'Veuillez entrer votre email',
				placeCode:'Remplir le Code de vérification',
				placePhone:'téléphone',
				submit:'Créer un compte',
				have:'Mon compte?',
				sign:'Aller à la connexion'
			},
			logistics:{
				navTitle:'Détails logistiques',
				expName:'Entreprise de logistique',
				expNo:'Numéro de vos commandes',
			},
			userIntegral:{
				now:'Points actuels',
				totalInt:'Points accumulés',
				totalPay:'Consommations cumulées',
				freeze:'Points de gel',
				tabNav:[
					{name:"Détails du score"},
					{name:"Augmentation du score"},
				],
				shopAdd:'Gagnez des points pour vos achats',
				make:'gagner des points',
				empty:'Points non encore enregistrés'
			},
			replyList: {
				navTitle: 'Liste des évaluations'
			},
			wallet: {
				navTitle: 'Liste des évaluations',
				all: 'Tout',
				income: 'Revenu',
				spending: 'Depense',
				tableColumn: {
					type: 'Type',
					amount: 'Montant',
					time: 'Date'
				}
			},
			invoiceList: {
				navTitle: 'Liste des factures',
				openedCount: 'Facture ouverte',
				applyingCount: 'Facture en cours',
				orderNum: 'Numéro de commande',
				tableColumn: {
					info: 'Informations sur la facture',
					amount: 'Montant',
					title: 'Facture',
					type: 'Type de facture',
					date: 'Date de la facture',
					status: 'Progrès de la facture',
					actions: 'Opération de la facture'
				},
				actionBtn: {
					viewInvoice: 'Voir la facture',
					orderDetails: 'Détails du commande'
				}
			}
		},
		store: {
			search: 'Rechercher un magasin',			
			followed: 'Suivi',
			follow: 'Attention',
			storeRating: 'Classement des magasins',
			storeQualification: 'Qualification du magasin',
			storeIntroduction: 'Profil du magasin',
			storeAddress: 'Adresse',
			storePhone: 'Numéro de contact',
			storeService: 'Service à la clientèle',
			storeTime: "Heure d'ouverture",
			storeName: 'Nom du marchand',
			userName: "Nom de l'utilisateur",
			phone: 'Téléphone',
			emil:'E - mail',
			code: 'Code',
			getCode: 'Code',
			class:'Classification des commerçants',
			type:'Type de magasin',
			place1:"Veuillez télécharger l'image de la licence commerciale et des certificats de qualification pertinents de l'industrie",
			place2: "Jusqu'à 10 images peuvent être téléchargées et le format supporte JPG, PNG, JPEG",
			agree:'Lire et accepter',
			agreement:'Accord de résidence',
			submit:'Présentation de la demande',
			agreement2:'Accord de résidence des commerçants',
			Tips1:'Félicitations, vos données ont été soumises avec succès!',
			Tips2:"On s'attend à ce que l'examen soit terminé dans les 15 jours ouvrables et que le service à la clientèle de la plateforme vous contacte en temps opportun!",
			Tips3:"Retour à la page d'accueil",
			title1:'Entrée des commerçants',
			title2:'Venez nous rejoindre.',
			street: 'Shop Street',
			keyword: 'Mots clés',
			merInfo: 'Détails du magasin',
			index: "Page d'accueil",
			classify: 'Classification',
			collar: 'Coupons',
			call: 'Service',
			people: 'Followers',
			delFollow: "Annuler l'attention",
			selfSupport: 'Indépendants',
      homeNav: [
        {name: "Page d'accueil"},
        {name: 'Classification'},
        {name: 'Coupons'}
      ]
		}
	},
	message:{
		login:{
			loginLoading:'Connexion Chargement',
			getting:'Obtenir',
			emailEmpty:'Veillez remplir votre émail',
			correctEmail:"Veuillez renseigner l'e-mail correct",
			emptyPassword:'Veuillez remplir le mot de passe',
			againPassword:'Veuillez confirmer votre mot de passe',
			diffPassword:'Le mot de passe ne correspond pas',
			emptyPhone:'veuillez remplir le numéro de  portable',
			emptyCaptche:'Veuillez remplir le code de vérification',
			correctCaptche:'Veuillez entrer le code de vérification correct',
			loginSuccess:'Connexion réussie',
			resetSuccess:'Réinitialisation du mot de passe réussie  ',
			name:'Veuillez renseigner le nom du destinataire ',
			detail:"Veuillez remplir l'adresse détaillée",
			postCode:'Veuillez renseigner le code postal',
			save:'Fait une sauvegarde',
			updateSU:'Modifié avec succès',
			saveSU:'Enregistré avec succès',
			prompt:'Indiquer',
			confirmDel:'Vous êtes sûr de vouloir le supprimer?',
			logout:'Êtes-vous sûr de vouloir vous déconnecter?',
			notExist:"L'adresse par défaut que vous avez définie n'existe pas",
			setSU:'Réglé avec succès',
			delSU:'Supprimé avec succès',
			calSU:'Annulation réussie',
			send:'Envoyer',
			resend:'Renvoyer',
			remaining:'Restant',
			loginSure: 'Utiliser ce mot de passe pour rester connecté après modification？',
			loginFacebook: "L'utilisateur actuel n'est pas connecté à Facebook ou à votre page Web",
      registerSU:'Inscription réussie',
      agreement: "Veuillez vérifier l'Accord de confidentialité de l'utilisateur",
      agree: "J'ai lu et accepté",
      agreementName: 'Protocole utilisateur'
		},
		pay:{
			orderFail:'Paiement échoué',
			error:"Les paramètres manquants ne peuvent pas afficher l'état du paiement de la commande",
			errorOrder: 'Impossible de voir les détails de la commande sans le numéro de commande'
		},
		orderConfirm:{
			payType:'Veuillez sélectionner le mode de paiement',
			emptyAddress:'Veuillez sélectionner une adresse de livraison',
			payLoading:'Paiement de la commande',
			productInfo: 'Informations sur le produit'
		},
		tips: {
			time: 'Date de soumission',
			adopt:'Approuvé',
			noadopt: 'Échec de la vérification',
			reason: 'Raisons',
			stay: 'À examiner',
			edit: 'Édition',
			see: 'Voir',
			again: 'Soumettre à nouveau',
			shoppingSU: 'Ajout réussi du panier',
			loding: 'Loading...',
			selectAddress: "Sélectionner l'adresse",
			selectOther: 'Sélectionner une autre adresse',
			surePay: "Êtes - vous sûr de payer la commande",
			sureDel: "Confirmer la suppression de l'ordre",
			upPic:"Jusqu'à 5 téléchargements",
			edidM: 'Cliquez pour modifier le mot de passe',
			sold: 'Vendu',
			changeGoods: 'Veuillez sélectionner un article',
      picTips: 'Le format de téléchargement est JPG, PNG',
      noEvaluation: 'Sans commentaires~',
      more: 'afficher plus',
      hide: 'cacher plus',
      noDetal: 'Pas encore de détails sur le produit',
      getSU: 'Reçu avec succès',
      browser: 'En raison de la fonctionnalité limitée du navigateur 360, veuillez appuyer sur Ctrl+D pour collecter manuellement!',
      nubrowser: 'Votre navigateur ne le supporte pas, veuillez appuyer sur Ctrl+D pour ajouter manuellement!',
      error1: "Désolé, une erreur s'est produite sur la page que vous avez visitée",
      error2: 'Échec du chargement',
      error3:'Mauvaise Demande',
      error4:'Veuillez vérifier votre fichier de configuration',
      placeLogin: 'veuillez vous connecter'
		},
		settled: {
			emptyName:"Veuillez saisir un nom d'entreprise",
			emptyRealName:"Veuillez saisir un nom",
			emptyCaptcha:"Veuillez remplir le Code de vérification",
			emptyCategory:"Veuillez sélectionner la catégorie Merchant",
			emptyIsAgree:"Veuillez cocher et accepter l'Accord de résidence",
			emptyIsPicture:"Veuillez télécharger l'image de qualification",
			appleTips: "Il n'y a pas de dossier de demande pour le moment."
		}
	}
}
